// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__xaPBq","name":"Header_name__1xksz","birthday":"Header_birthday__1lBK5","skeleton":"Header_skeleton__vLyMN"};